import React from 'react';
import './RedButton.scss';
import { FaSortDown } from 'react-icons/fa'
import Loading from "../../Loading/Loading";

const RedButton = ({className, onClick, name, icon, disable, loading = false}) => (
  <div className="red-button-main-container">
    <button className={'red-button-main ' + className}
            style={{visibility:loading ? 'hidden' : 'visible'}}
            onClick={onClick}
            disabled={loading || disable}>
      {name}
      
      {icon ?
        <FaSortDown className="button-icon"/>
        :
        null
      }
    </button>
    <Loading className="red-button-loading"
             loading={loading}
             showLabel={false}
    />
  </div>
);

export default RedButton;
